(ns entities.insurance.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.insurance.specs :as sp]
    )
  )

(def path [:entities :insurance])

(rf/reg-entity
  :insurance
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/insurance)
                :success [:insurance/fetched]
                :error [:insurance/fetch-errored]}})

   :patch
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/update-insurance {:input {:insurancePolicies data}})
                :success [:insurance/updated]
                :error [:insurance/update-errored]}})})

(rf/reg-event-db
  :insurance/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :insurance-policies])))

(rf/reg-event-db
  :insurance/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :insurance-policies])))

(rf/reg-event-db
  :insurance/updated
  (rf/path path)
  (fn [_ [data]]
    (:update-insurance-policies data)))

(rf/reg-event-db
  :insurance/update-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (:update-insurance-policies data)))
